import { render, staticRenderFns } from "./Schema.vue?vue&type=template&id=31b982c8&scoped=true&lang=pug&"
import script from "./Schema.vue?vue&type=script&lang=ts&"
export * from "./Schema.vue?vue&type=script&lang=ts&"
import style0 from "./Schema.vue?vue&type=style&index=0&id=31b982c8&lang=scss&scoped=true&"
import style1 from "./Schema.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b982c8",
  null
  
)

export default component.exports